import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { map, retry, share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class WsService {
    public messages: Rx.Subject<string>;
    public ws: any;
    public currentSimulationId: string;
    private subject: Rx.Subject<MessageEvent>;

    constructor() { }

    public open() { }

    public connect(simulationId: string, participantId?: string): Rx.Subject<MessageEvent> {
        if (!this.subject && simulationId != this.currentSimulationId) {
            this.subject = this.create(simulationId, participantId);
            this.messages = <Rx.Subject<any>>this.subject.pipe(
                map((response: MessageEvent): any => {
                    return response.data;
                }),
            );

        }

        this.currentSimulationId = simulationId;
        return this.subject;
    }
    private create(simulationId: string, participantId?: string): Rx.Subject<MessageEvent> {
        let url = `${environment.api.socketServer}?simulationId=${simulationId}`;
        if (participantId) {
            url += `&participantId=${participantId}`;
        }
        this.ws = new WebSocket(url);
        const observable = Rx.Observable.create((obs: Rx.Observer<MessageEvent>) => {
            this.ws.onmessage = obs.next.bind(obs);
            this.ws.onerror = obs.error.bind(obs);
            this.ws.onclose = obs.complete.bind(obs);

            return this.ws.close.bind(this.ws);
        }).pipe(share(), retry());
        const observer = {
            next: (data: Object) => {
                if (this.ws.readyState === WebSocket.OPEN) {
                    this.ws.send(data);
                }
            },
        };

        return Rx.Subject.create(observer, observable);
    }

    public close() {
        if (this.ws) {
            this.ws.close();
            console.log('websocket connection closed');
            // this.subject = null as any;
        }
    }
}
